"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const toolkit_1 = require("@reduxjs/toolkit");
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const react_i18next_1 = require("react-i18next");
const businessShareholderCard_1 = __importDefault(require("./businessShareholderCard/businessShareholderCard"));
const labelButton_1 = __importDefault(require("../../../components/labelButton/labelButton"));
const primaryButton_1 = __importDefault(require("../../../components/primaryButton/primaryButton"));
const text_1 = __importStar(require("../../../components/text/text"));
const store_1 = require("../../../store");
const theme_1 = __importDefault(require("../../../styles/theme"));
const homeSlice_1 = require("../../home/homeSlice");
const businessOrganizationSlice_1 = require("../businessOrganization/businessOrganizationSlice");
const styles_1 = __importDefault(require("../../../styles/styles"));
const businessShareholdersConstants_1 = require("./businessShareholdersConstants");
const analytics_1 = require("../../../utils/analytics/analytics");
const BusinessShareholdersList = ({ shareholders, setShareholders, setShowShareholdersComponent, setSelectedShareholder, canContinueApplication, }) => {
    const dispatch = (0, store_1.useAppDispatch)();
    const { logEventWithExtraProperties } = (0, analytics_1.useAnalytics)();
    const { t } = (0, react_i18next_1.useTranslation)();
    // Delete shareholder api call
    const submitDelete = async (shareholder_user_id) => {
        const result = await dispatch((0, businessOrganizationSlice_1.submitBusinessDeleteShareholder)({ shareholderId: shareholder_user_id }));
        logEventWithExtraProperties('api_call', {
            name: 'delete_business_shareholder',
            status: 'submitted',
            location: 'screen_BusinessShareholdersList',
        });
        if ((0, toolkit_1.isFulfilled)(result)) {
            logEventWithExtraProperties('api_call', {
                name: 'delete_business_shareholder',
                status: 'success',
                location: 'screen_BusinessShareholdersList',
            });
            if (shareholders) {
                const newList = shareholders.filter((el) => el.user_id !== shareholder_user_id);
                if (newList) {
                    setShareholders(newList);
                }
            }
        }
        else {
            logEventWithExtraProperties('api_call', {
                name: 'delete_business_shareholder',
                status: 'fail',
                location: 'screen_BusinessShareholdersList',
            });
        }
    };
    return (react_1.default.createElement(react_native_1.View, null,
        react_1.default.createElement(react_native_1.View, null,
            shareholders.length === 0 ? (react_1.default.createElement(react_native_1.View, { style: [styles_1.default.centerChildHorizontalVertical] },
                react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_SUBTITLE }, t('businessShareholderList.add_shareholders')))) : (shareholders.map((shareholder) => (react_1.default.createElement(react_native_1.View, { key: shareholder.id, style: styles_1.default.minimumMarginBetweenElementsVertically },
                react_1.default.createElement(businessShareholderCard_1.default, { businessShareholder: shareholder, deleteShareholder: submitDelete, editShareholder: () => {
                        setShowShareholdersComponent(businessShareholdersConstants_1.SHAREHOLDER_COMPONENT_DETAILS);
                        setSelectedShareholder(shareholder);
                    } }))))),
            react_1.default.createElement(react_native_1.View, { style: [styles_1.default.centerChildHorizontalVertical] },
                react_1.default.createElement(labelButton_1.default, { title: "ADD SHAREHOLDER", textColor: theme_1.default.colors.COLOR_PRIMARY, onPress: () => setShowShareholdersComponent(businessShareholdersConstants_1.SHAREHOLDER_COMPONENT_DETAILS), disabled: false, eventName: "add_business_shareholder" }))),
        canContinueApplication && (react_1.default.createElement(primaryButton_1.default, { title: "Save", onPress: () => dispatch((0, homeSlice_1.showMessage)()), disabled: false, eventName: "save_business_shareholder" }))));
};
exports.default = BusinessShareholdersList;
